//These will be the genres that actually display to the user as genre selectable.
//The DataLoading or whatever will also use these to compare.
//Ie don't have game x, game x has important genres a and b. search genre db for games w/
//genres a or b, then return language videos for those games


const ImportantGenres = ["Independent", "Strategy", "RPG", "2D", "Adventure", "Simulation", "Fantasy", "Sport", "First Person Shooter", "Horror", "Comedy", "Battle Royale", "Auto Battlers"]

export default ImportantGenres